<template>
  <fin-portfolio-distribution-chart :series-object="seriesObject"
                                    title="Assetklassen"/>
</template>

<script>
import AssetClasses from '@/mocks/AssetClasses'
import FinPortfolioDistributionChart from '@/components/pages/myPortfolio/PortfolioDistributionChart'

export default {
  name: 'FinAssetDistributionChart',
  components: {FinPortfolioDistributionChart},
  props: {
    actual: {
      type: Array
    },
    target: {
      type: Array
    },
    active: {
      type: String
    }
  },
  computed: {
    seriesObject() {
      return {
        data: AssetClasses.items.map((ac) => ({
          ...ac,
          y: this.actual?.find(a => a.name === ac.id)?.percentage || 0,
          target: this.target?.find(t => t.name === ac.id)?.percentage || 0,
          sliced: this.active === ac.id
        }))
      }
    }
  }
}
</script>

<style scoped>

</style>
